import { render, staticRenderFns } from "./MainHeading.vue?vue&type=template&id=5f3b657c&scoped=true&"
import script from "./MainHeading.vue?vue&type=script&lang=js&"
export * from "./MainHeading.vue?vue&type=script&lang=js&"
import style0 from "./MainHeading.vue?vue&type=style&index=0&id=5f3b657c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b657c",
  null
  
)

export default component.exports